import React, {useState} from 'react';
import "./MoreDots.css";
import more_dots from "../../../Assets/icons/more_vert.svg";
import { useNavigate } from "react-router-dom";
import MyModal from "../MyModal/MyModal";
import Service from "../../../API/Service";

const MoreDots = ({ id, entity, isOpen, onToggle, setData, text}) => {
    const navigate = useNavigate();
    const [modal, setModal] = useState(false);
    const btnText = "Delete"

    const handleDelete = async () => {
        try {
            await Service.deleteItem(entity, id);
            setData(prevData => prevData.filter(item => item.id !== id));
            setModal(false);
        } catch (error) {
            console.error("Ошибка при удалении:", error);
        }
    };

    return (
        <div className="more-dots">
            <img onClick={onToggle} src={more_dots} alt="more_dots" />
            <MyModal
                visible={modal}
                setVisible={setModal}
                onClick={handleDelete}
                text={text}
                btnText={btnText}
            />
            {isOpen && (
                <div className="menu">
                    {entity === "constants" ? (
                        <>
                            <div
                                className="view"
                                onClick={() => navigate(`/${entity}/${id}`)}
                            >
                                View details
                            </div>
                            <div
                                className="edit"
                                style={{
                                    borderBottomRightRadius: "8px",
                                    borderBottomLeftRadius: "8px"
                                }}
                                onClick={() => navigate(`/${entity}/${id}/edit`)}
                            >
                                Edit
                            </div>
                        </>
                    ):(
                        <>
                            <div
                                className="view"
                                onClick={() => navigate(`/${entity}/${id}`)}
                            >
                                View details
                            </div>
                            <div
                                className="edit"
                                onClick={() => navigate(`/${entity}/${id}/edit`)}
                            >
                                Edit
                            </div>
                            <div
                                className="delete"
                                onClick={() => {
                                    setModal(true);
                                    onToggle();
                                }}
                            >
                                Delete
                            </div>
                        </>
                    )}
                </div>
            )}
        </div>
    );
};

export default MoreDots;
